import React from "react";
import ExitLink from "~app/components/ExitLink";
import { useT, useResources } from "~app/BundleProvider";

const HowieHeader = () => {
  const t = useT();
  const r = useResources();
  return (
    <div className="HowieHeader__layout">
      <img
        className="HowieHeader__logo"
        src={r("header.svg")}
        alt={t("how-science-works")}
      />

      <img
        className="HowieHeader__howie"
        src={require("~app/resources/images/howie-header/howie.svg")}
        alt="Howie"
      />

      <div className="HowieHeader__exit">
        <ExitLink />
      </div>
    </div>
  );
};

export default HowieHeader;



// WEBPACK FOOTER //
// ./src/components/HowieHeader.js